var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "optix-chart-card" }, [
    _c("div", { staticClass: "chart-title" }, [
      _vm._v("\n    Score distribution by tier\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "chart-canvas-wrap" }, [
      _c("canvas", { ref: "chartCanvas" }),
    ]),
    _vm._v(" "),
    !_vm.totalProducts
      ? _c("div", { staticClass: "chart-empty-state" }, [
          _vm._v("\n    No products to chart yet.\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }